window.customElements.define(
    'notification-banner',
    class extends HTMLElement {
        connectedCallback() {
            let close = this.querySelector('[data-notification-banner-close]');

            close.addEventListener(
                'click', (event) => {
                    event.preventDefault();
                    this.setAttribute('hidden', 'hidden');
                    this.classList.add("u-stack__cozy");
                }
            );

            this.addEventListener(
                'click',
                (event) => {
                    if (event.target.hasAttribute('href') === false) {
                        return;
                    }

                    const href = event.target.getAttribute('href');

                    if (href?.startsWith('#')) {
                        event.preventDefault();

                        const el = document.getElementById(href.substring(1));

                        el.focus();

                        if (el.closest('.form-item')) {
                            el.closest('.form-item').scrollIntoView();
                        } else {
                            el.scrollIntoView();
                        }
                    }
                },
            )
        }
    },
);
